export const toPageTitle = title => {
  const { view, detail } = title
  return view ? `${view} - iDeal` : detail ? `${detail} - iDeal` : 'iDeal'
}
